// Header : menu mobile (fermeture par lien, Échap, clic extérieur, animée) et compteur du panier.
if (!customElements.get('mp-header')) {
  class MpHeader extends HTMLElement {
    connectedCallback() {
      this.menu = this.querySelector('.mp-header__menu-mobile');
      this.compteur = this.querySelector('[data-mp-panier-compteur]');
      this.lienPanier = this.querySelector('[data-mp-panier-lien]');

      this.surMajPanier = this.surMajPanier.bind(this);
      document.addEventListener('mp:panier:maj', this.surMajPanier);

      // Avant la sortie anticipée plus bas : doit fonctionner même sans menu déroulant
      this.masquageAuDefilement();

      // Menu mobile : fermé par Échap ou clic extérieur,
      // ouverture et fermeture animées (la fermeture attend la fin de l'animation)
      this.deroulants = [...this.querySelectorAll('[data-mp-header-deroulant]')];
      if (this.deroulants.length === 0) return;
      this.deroulants.forEach((deroulant) => {
        deroulant.querySelector('summary').addEventListener('click', (event) => {
          if (!deroulant.open) return;
          event.preventDefault();
          this.fermer(deroulant);
        });
        deroulant.addEventListener('toggle', () => {
          if (!deroulant.open) return;
          this.deroulants.forEach((autre) => {
            if (autre !== deroulant) this.fermer(autre, false);
          });
        });
        deroulant.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && deroulant.open) {
            this.fermer(deroulant);
            deroulant.querySelector('summary').focus();
          }
        });
      });
      this.menu?.addEventListener('click', (event) => {
        if (event.target.closest('a')) this.fermerMenu();
      });
      this.surClicExterieur = (event) => {
        this.deroulants.forEach((deroulant) => {
          if (deroulant.open && !deroulant.contains(event.target)) this.fermer(deroulant);
        });
      };
      document.addEventListener('click', this.surClicExterieur);
    }

    // animer = false : fermeture immédiate (ex. quand un autre panneau s'ouvre à la place)
    fermer(deroulant, animer = true) {
      if (!deroulant.open || deroulant.classList.contains('is-fermeture')) return;
      const panneau = deroulant.querySelector('.mp-header__panneau');
      const sansAnimation = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!animer || !panneau || sansAnimation) {
        deroulant.open = false;
        return;
      }
      deroulant.classList.add('is-fermeture');
      // Filet de sécurité : si l'animation ne se termine pas (onglet en arrière-plan…), on ferme quand même
      const terminer = () => {
        clearTimeout(minuteur);
        panneau.removeEventListener('animationend', terminer);
        deroulant.classList.remove('is-fermeture');
        deroulant.open = false;
      };
      const minuteur = setTimeout(terminer, 350);
      panneau.addEventListener('animationend', terminer);
    }

    disconnectedCallback() {
      document.removeEventListener('mp:panier:maj', this.surMajPanier);
      if (this.surClicExterieur) document.removeEventListener('click', this.surClicExterieur);
      if (this.surDefilement) window.removeEventListener('scroll', this.surDefilement);
    }

    // Masque l'en-tête au défilement vers le bas, le ramène au défilement vers le haut.
    masquageAuDefilement() {
      this.section = this.closest('.shopify-section');
      // Sans position collante, l'en-tête défile déjà : rien à masquer
      if (!this.section || getComputedStyle(this.section).position !== 'sticky') return;

      // Seuil : absorbe les micro-mouvements du trackpad et le rebond élastique iOS
      const SEUIL = 6;
      let dernier = Math.max(0, window.scrollY);
      let enAttente = false;

      const evaluer = () => {
        enAttente = false;
        const y = Math.max(0, window.scrollY);
        const delta = y - dernier;
        if (Math.abs(delta) < SEUIL) return;

        // Un menu ouvert reste visible, et on ne masque pas en haut de page
        const menuOuvert = !!this.querySelector('[data-mp-header-deroulant][open]');
        if (delta > 0 && y > this.offsetHeight && !menuOuvert) {
          this.section.classList.add('is-cachee');
        } else if (delta < 0 || menuOuvert) {
          this.section.classList.remove('is-cachee');
        }
        dernier = y;
      };

      this.surDefilement = () => {
        if (enAttente) return;
        enAttente = true;
        requestAnimationFrame(evaluer);
      };
      window.addEventListener('scroll', this.surDefilement, { passive: true });
    }

    fermerMenu() {
      if (this.menu) this.fermer(this.menu);
    }

    // Émis par le tiroir panier : detail = { item_count, panier }.
    // On ne compte que les produits principaux : les options payantes sont exclues.
    surMajPanier(event) {
      let nombre = event.detail?.item_count;
      const articles = event.detail?.panier?.items;
      if (Array.isArray(articles)) {
        const exclus = (this.lienPanier?.dataset.mpOptionsExclues || '')
          .split(',')
          .filter(Boolean)
          .map(Number);
        nombre = articles
          .filter((article) => !exclus.includes(article.product_id))
          .reduce((total, article) => total + article.quantity, 0);
      }
      if (typeof nombre !== 'number' || !this.compteur) return;
      this.compteur.textContent = nombre;
      this.compteur.hidden = nombre === 0;
      this.lienPanier.setAttribute('aria-label', `${this.lienPanier.dataset.libelle} (${nombre})`);
    }
  }

  customElements.define('mp-header', MpHeader);
}
